var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-new-bubble",class:{ 'header-new-bubble--alt': _vm.alt },attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"header-new-bubble__text",class:{ fadeout: _vm.animate }},[_vm._v(_vm._s(_vm.$t('words.new').toUpperCase()))]),_vm._v(" "),_c('div',{staticClass:"header-new-bubble__bubble"})])
}
var staticRenderFns = []

export { render, staticRenderFns }